import { jsx, jsxs } from 'react/jsx-runtime';
import { messageStyle } from '../styles.js';
var StubbedWarningMessage = function StubbedWarningMessage(_ref) {
  var message = _ref.message;
  return (message === null || message === void 0 ? void 0 : message.title) && jsx("div", {
    style: messageStyle,
    children: jsxs("div", {
      children: [jsx("strong", {
        children: message.title
      }), (message === null || message === void 0 ? void 0 : message.body) && jsx("div", {
        children: message === null || message === void 0 ? void 0 : message.body
      })]
    })
  });
};
export { StubbedWarningMessage as default };